import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { MarketClient, MarketView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class MarketService {
    constructor(private readonly client: MarketClient) {}

    async getById(id: number): Promise<MarketView> {
        return await lastValueFrom(this.client.marketGetById(id));
    }

    async getAll(): Promise<MarketView[]> {
        return await lastValueFrom(this.client.marketGetAll());
    }
}
